// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_p6-8";
export var editMode = "_p6-3";
export var headerRow = "_p6-a";
export var headerTitle = "_p6-b";
export var product = "_p6-1";
export var productDetails = "_p6-5";
export var productDivider = "_p6-7";
export var productImage = "_p6-2";
export var productInfo = "_p6-4";
export var productTitle = "_p6-6";
export var strikethrough = "_p6-9";
export var upsellProductsCard = "_p6-0";